const routes = {
    path: 'leads',
    name: 'Leads',
    component: () => import('./Listagem.vue'),
    meta: {
        rules: ['RD-LEADS-00'],
    },
    children: [
        {
            path: ':id',
            name: 'Leads_Detalhar',
            component: () => import('./Detalhar.vue'),
            meta: {
                rules: ['RD-LEADS-00'],
            },
        },
        // {
        //     path: 'inserir',
        //     name: 'Associados_Inserir',
        //     component: () => import('./Inserir.vue'),
        //     meta: {
        //         rules: ['ASSOCIADOS-01'],
        //     },
        // },
        // {
        //     path: ':id/atualizar',
        //     name: 'Associados_Atualizar',
        //     component: () => import('./Atualizar.vue'),
        //     meta: {
        //         rules: ['ASSOCIADOS-03'],
        //     },
        // },
    ],
};

export default routes;
